import { IButtonProps, Button as NBButton } from "native-base";
import { ColorType } from "native-base/lib/typescript/components/types";
import React from "react";

type ComponentProps = {
  textColor?: ColorType;
} & IButtonProps;

const FormButton = ({ textColor, ...props }: ComponentProps) => {
  return (
    <NBButton
      variant="solid"
      _text={{
        color: textColor || "#FFFF",
        fontWeight: "semibold",
      }}
      size="lg"
      shadow="4"
      rounded="md"
      {...props}
    />
  );
};

export default FormButton;
